import Vue from "vue";

export default {
  getWorkShifts({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentPage,
        per_page: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(state.filterValue != "" && { status: state.filterValue }),
      };

      Vue.$http
        .get("/attendance/shift/workshift", { params })
        .then(response => {
          commit("workShifts", response.data.results);
          commit("totalWorkShifts", response.data.total);
          commit("tableLoader", false);

          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getWorkShift({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/shift/workshift/${id}`)
        .then(response => {
          commit("tableLoader", false);

          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getShiftTypes({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/attendance/shift/settings/shift-type")
        .then(response => {
          commit("shiftTypes", response.data);
          commit("totalWorkShifts", response.data.total);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getClockSetup(_, name = "IGNORE_FUNCTION_KEY") {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/settings?name=${name}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateClockSetup(_, payload, name = "IGNORE_FUNCTION_KEY") {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/attendance/settings?name=${name}`, { ...payload, name })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getWorkShifts");
  },

  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getWorkShifts");
  },

  createWorkShift(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/attendance/shift/workshift`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  saveShiftType(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/attendance/shift/settings/shift-type`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteShiftType(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/attendance/shift/settings/shift-type/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  updateWorkShift(_, params) {
    const id = params.id;
    delete params.id;
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/attendance/shift/workshift/${id}`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  deleteWorkShift(_, id) {
    const params = { force: true };
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/attendance/shift/workshift/${id}`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  assignWorkShift(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/attendance/shift/workshift/assign`, params)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  unassignAnEmployeeFromWorkShift(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`attendance/shift/workshift/unassign`, params)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  generateRoster({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      const a = state.rosterParam;
      const params = {
        ...a,
        page: state.currentPage,
        perPage: state.perPage,
      };
      Vue.$http
        .get("/attendance/shift/roster", { params })
        .then(response => {
          commit("allRoster", response.data.results);
          commit("totalRoster", response.data.total);
          commit("rosterDates", response.data.rosterDates);
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  handleRosterSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("generateRoster");
  },

  handleRosterCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("generateRoster");
  },

  getBranches({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/branches")
        .then(response => {
          commit("branches", response.data.results);
          resolve(response.data.results);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getDepartments({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("organization/departments")
        .then(response => {
          commit("departments", response.data);
          resolve(response.data.results);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  downloadReport({ commit, state }, format) {
    commit("tableLoader", true);
    const a = state.rosterParam;
    const params = {
      ...a,
      page: state.currentPage,
      perPage: state.perPage,
    };
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`attendance/shift/roster/download/${format}`, params)
        .then(response => {
          commit("tableLoader", false);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoader", false);
          reject(error);
        });
    });
  },
  generateShifts({ commit }, inputData) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);
      Vue.$http
        .get("/attendance/shift/calendar", { params: inputData })
        .then(response => {
          // Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
};
